import moreOption from '../../assets/more_vert.png'
import workHis from '../../assets/work_history.png'
import workAlert from '../../assets/work_alert.png'
import addUpdate from '../../assets/add_ad.png'
import { useDispatch, useSelector } from 'react-redux';
import CandidateConversionChart from './Charts/CandidateConversionChart';
import StatusOverview from './Charts/StatusOverview';
import { getDashboardData, subscribeDetail } from '../services/operations/profileAPI';
import { useEffect, useState } from 'react';
import Loader from "../Loader/Loader"

const BusinessDashBoard = () => {


  const [dashboardData, setDashboardData] = useState([]);
  const [paymentDetail, setPaymentDetail] = useState([]);
  const [filter, setFilter] = useState("Monthly");

  const statuses = [
    { label: "Active", color: "rgba(174, 41, 149, 1)", progress: dashboardData?.job_counts_all?.active_applicant_percent || 0, count: dashboardData?.job_counts_all?.active || 0, },
    { label: "Closed", color: "rgba(45, 118, 253, 1)", progress: dashboardData?.job_counts_all?.closed_applicant_percent || 0, count: dashboardData?.job_counts_all?.closed || 0, },
    { label: "Pending", color: "rgba(36, 164, 127, 1)", progress: dashboardData?.job_counts_all?.pending_applicant_percent || 0, count: dashboardData?.job_counts_all?.pending_applicant || 0, },
    { label: "Hired", color: "rgba(255, 165, 46, 1)", progress: dashboardData?.job_counts_all?.hired_percent || 0, count: dashboardData?.job_counts_all?.hired || 0, },
  ];

  const updateList = [
    "We are excited to introduce our new training programs designed to enhance..",
    "We are excited to introduce our new training programs designed to enhance..",
    "We are excited to introduce our new training programs designed to enhance.."
  ]
  const payments = [
    { date: "27 Apr", company: "Amazon", description: "Purchase", amount: -32 },
    { date: "25 Apr", company: "Freelance", description: "Project Payment", amount: +120 },
    { date: "22 Apr", company: "Netflix", description: "Subscription", amount: -15 },
  ];

  const user = useSelector((state) => state.profile.user)
  const loading = useSelector((state) => state.auth.loading);
  const token = useSelector((state) => state.auth.token)
  const dispatch = useDispatch();

  const getDashboardstat = async (filter) => {
    const result = await dispatch(getDashboardData(token, filter))
    if (result?.data?.data) {
      setDashboardData(result.data.data);
    }
  }


  const getSubscribeDetails = async () => {
    const response = await dispatch(subscribeDetail(token));
    if (response?.data?.data) {
      setPaymentDetail(response.data.data)
    }
  }

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'long',
    });
  };


  useEffect(() => {
    getSubscribeDetails()
  }, [])
  useEffect(() => {
    getDashboardstat(filter)
  }, [filter])


  const userCount = paymentDetail?.user_count ?? 1;

  return (
    <div className="business-dashboard">
      {loading && <Loader />}
      <div className="first-col">
        <div className="dashboard-section first-section-first">
          <p className="first-col-heading">Hi {user?.name}</p>
          <p className="first-col-subheading">Every application can increase the success rate by 21%. lets make this one count !</p>
        </div>

        <div className="dashboard-section first-section-third" style={{ padding: "0px" }}>
          <div className="first-section-third-heading">
            <p style={{ color: "white", fontWeight: "600", fontSize: "30px", padding: "10px" }}>Hiring Overview</p>
            {/* <img src={moreOption} alt='more' width={"30px"} height={"30px"} /> */}
          </div>
          <div className='first-section-third-desc'>
            <div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-start", gap: "15px", marginLeft: "10px", width: "100%" }}>
              <p style={{ color: "rgba(217, 217, 217, 1)", fontSize: "18px", display: "flex", alignItems: "center", gap: "10px" }}><img src={workHis} alt='work-his' />{dashboardData?.job_counts_all?.active_job || 0} Active Jobs</p>
              <p style={{ color: "rgba(217, 217, 217, 1)", fontSize: "18px", display: "flex", alignItems: "center", gap: "10px" }}><img src={workAlert} alt='work-his' />{dashboardData?.job_counts_all?.closed_job || 0} Closed Jobs</p>
            </div>
            <div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-end", width: "100%" }}>
              <div style={{ display: "flex", flexDirection: "column", backgroundColor: "rgba(173, 201, 254, 1)", textAlign: "center", borderRadius: "15px 0px 0px 15px", padding: "10px" }}>
                <p style={{ color: "rgba(174, 41, 149, 1)", fontSize: "36px", fontWeight: "700" }}>{dashboardData?.job_counts_all?.active_applicant_percent || 0}%</p>
                <p style={{ color: "rgba(28, 27, 31, 1)", fontSize: "16px", fontWeight: "700" }}>Active Hiring</p>
              </div>
              <div style={{ display: "flex", flexDirection: "column", textAlign: "center", backgroundColor: "rgba(173, 201, 254, 1)", borderRadius: "0px 15px 15px 0px", padding: "10px" }}>
                <p style={{ color: "rgba(36, 164, 127, 1)", fontSize: "36px", fontWeight: "700" }}>{dashboardData?.job_counts_all?.hired_percent}%</p>
                <p style={{ color: "rgba(28, 27, 31, 1)", fontSize: "16px", fontWeight: "700" }}>Success Rate</p>
              </div>
            </div>
          </div>
        </div>
        <div className="dashboard-section second-section-third">
          <div className="first-section-third-heading">
            <p className='section-title'>Updates</p>
            <img src={addUpdate} alt='more' width={"21.9px"} height={"17px"} />
          </div>
          {
            updateList.map((list, index) => (
              <div key={index} className="list-item">
                <p style={{ padding: "10px", color: "rgba(59, 59, 60, 1)", fontSize: "13px" }}>{list}</p>
              </div>
            ))}
        </div>
      </div>

      <div className="second-col">
        {/* <CandidateConversionChart /> */}
        <div className="dashboard-section second-section-second">
          <p className="section-title">Offer Acceptance</p>
          <div className="status-container">
            <div className='status-label-container' style={{ justifyContent: "flex-start", gap: "40px" }}>
              {statuses.map((status, index) => (
                <div key={index} className="status-item">
                  <div className="status-label">
                    <div className="status-square" style={{ backgroundColor: status.color }}></div>
                    <span style={{ fontSize: "16px", fontWeight: "400", color: "rgba(0,0,0,0.7" }}>{status.label}</span>
                  </div>
                </div>
              ))}
            </div>
            <div className='status-label-container' style={{ backgroundColor: "rgba(205, 222, 255, 0.31)", borderRadius: "15px", height: "135px" }}>
              {statuses.map((status, index) => (
                <div className="progress-circle" key={index} style={{ position: 'relative' }}>
                  <div className="tooltip-dashboard-container">
                    <svg width="70" height="70">
                      <circle cx="35" cy="35" r="30" stroke="#ddd" strokeWidth="6" fill="none" />
                      <circle
                        cx="35"
                        cy="35"
                        r="30"
                        stroke={status.color}
                        strokeWidth="6"
                        fill="none"
                        strokeDasharray="188.4"
                        strokeDashoffset={188.4 - (status.progress / 100) * 188.4}
                        strokeLinecap="round"
                      />
                      <text x="35" y="42" textAnchor="middle" fontSize="18px" fontWeight="500" fill="black">
                        {status.count}
                      </text>
                    </svg>
                    <div className="tooltip-dashboard">{status.progress}%</div>
                  </div>
                </div>
              ))}

            </div>
          </div>
        </div>
        <StatusOverview data={dashboardData} filter={filter} setFilter={setFilter} />
      </div>

      <div className="third-col">
        <div className="dashboard-section third-section-first">
          <p className="section-title">Payment History</p>
          <div className="payment-list">
            {paymentDetail && paymentDetail.length > 0 ? (
              paymentDetail.map((payment, index) => {
                const userCount = payment?.user_count ?? 1;
                return (
                  <div
                    key={index}
                    className={`payment-item ${payment.amount >= 0 ? "positive" : "negative"}`}
                  >
                    <div className="payment-date">{formatDate(payment.date)}</div>
                    <div className="payment-info">
                      <p className="payment-desc">{payment?.description}</p>
                      <p className="company-name">
                        {userCount} {userCount > 1 ? "users" : "user"}
                      </p>
                    </div>
                    <div
                      className={`payment-amount ${payment.amount >= 0 ? "green-text" : "red-text"}`}
                    >
                      ${payment.amount}
                    </div>
                  </div>
                );
              })
            ) : (
              <p className="no-payment-message">No payment has been done yet.</p>
            )}
          </div>

          {/* <p style={{ textAlign: "right", color: "rgba(0, 0, 0, 0.7)", fontSize: "12px" }}>View All</p> */}
        </div>
        {/* <div className="dashboard-section third-section-second">Daily Action</div> */}
        <div className="job-postings-wrapper">
          <h3 className="job-postings-title">Job Postings</h3>

          <div className="job-postings-legend">
            <span><span className="dot blue-dot" />Active </span>
            <span><span className="dot purple-dot" /> Closed </span>
            <span><span className="dot green-dot" /> Pending </span>
          </div>

          <div className="job-postings-bar-container">
            <div className="job-postings-percents">
              <span className="percent blue">{dashboardData?.job_counts_all?.active_job_percent}%</span>
              <span className="percent purple">{dashboardData?.job_counts_all?.closed_job_percent}%</span>
              <span className="percent green">{dashboardData?.job_counts_all?.pending_job_percent}%</span>
            </div>

            <div className="bar-with-lines">
              <div className="job-postings-bar">
                <div className="bar blue-bar"
                  style={{
                    width: `${dashboardData?.job_counts_all?.active_job_percent}%`,
                  }} />
                <div className="bar purple-bar"
                  style={{
                    width: `${dashboardData?.job_counts_all?.closed_job_percent}%`,
                  }} />
                <div className="bar green-bar"
                  style={{
                    width: `${dashboardData?.job_counts_all?.pending_job_percent}%`,
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BusinessDashBoard;
